function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import useTableQuery from "../../components/hooks/table/useTableQuery";
import { useRef, useState } from 'react';
import { post } from "../../utils";

/**
 * AttachmentEntity
 */

export var useList = function useList() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSelectAll = _useState2[0],
    setIsSelectAll = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedRowKeys = _useState4[0],
    setSelectedRowKeys = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedRows = _useState6[0],
    setSelectedRows = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedNum = _useState8[0],
    setSelectedNum = _useState8[1];
  var search = useRef(null);
  var _useTableQuery = useTableQuery({
      url: '/erp/scm/receipt/list',
      method: 'POST',
      searchConnect: search,
      requestFilter: function requestFilter(q) {
        return q;
      }
    }),
    _useTableQuery2 = _slicedToArray(_useTableQuery, 2),
    tableData = _useTableQuery2[0],
    tableAction = _useTableQuery2[1];
  var multiExport = function multiExport() {
    post({
      url: "/erp/scm/receipt/export",
      data: _objectSpread(_objectSpread({}, tableData.requestQuery), {}, {
        orderCodes: selectedRowKeys,
        page: undefined
      })
    }).then(function (_ref) {
      var code = _ref.code,
        data = _ref.data;
      if (code === 0) {
        window.open(data);
      }
    });
  };
  var onSelectAll = function onSelectAll() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var num = arguments.length > 1 ? arguments[1] : undefined;
    setSelectedRowKeys(data.map(function (e) {
      return e.id;
    }));
    setSelectedRows(data);
    setSelectedNum(num);
    setIsSelectAll(true);
  };
  var onCancelSelectAll = function onCancelSelectAll() {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setSelectedNum(0);
    setIsSelectAll(false);
  };
  var onRowSelectionChange = function onRowSelectionChange(keys, rows) {
    setSelectedRowKeys(keys);
    setSelectedRows(rows);
    setSelectedNum(keys.length);
  };
  return {
    data: {
      search: search,
      tableData: tableData,
      isSelectAll: isSelectAll,
      selectedRowKeys: selectedRowKeys,
      selectedNum: selectedNum
    },
    action: {
      tableAction: tableAction,
      onCancelSelectAll: onCancelSelectAll,
      onSelectAll: onSelectAll,
      multiExport: multiExport,
      onRowSelectionChange: onRowSelectionChange
    }
  };
};